(function() {
    'use strict';
    /*
     * Copyright (c) 2019 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('ScripFormCtrl', ScripFormCtrl);

    ScripFormCtrl.$inject = ['_', 'FrequencyService', 'CommonI18nService'];

    function ScripFormCtrl(_, FrequencyService, CommonI18nService) {
        var vm = this;

        vm.i18n = CommonI18nService.pages.scripForm;

        vm.getFrequencyLabel = FrequencyService.getFrequencyLabel;
        vm.frequencyOptions = FrequencyService.frequencyOptions;

        vm.showAutoExpire = function() {
            return vm.editFlag ? vm.prescriptionObjectEdit.performOnce : vm.prescriptionObject.performOnce;
        };
    }
})();